/**
 * XML element `<color>` (Swing): `FF0000`, `#FF0000`, `0xFF0000`.
 * Returns a CSS color string, or undefined if empty/invalid wrapper.
 */
export function parseXmlElementColor(raw: unknown): string | undefined {
  let color = ''
  if (typeof raw === 'string' || typeof raw === 'number') {
    color = String(raw).trim()
  } else if (raw && typeof raw === 'object' && '_text' in (raw as object)) {
    color = String((raw as { _text?: unknown })._text ?? '').trim()
  } else {
    return undefined
  }
  if (!color || color === '[object Object]') return undefined

  if (/^0x/i.test(color)) {
    color = color.replace(/^0x/i, '')
  }
  if (/^#?[0-9a-fA-F]{3,8}$/.test(color)) {
    return color.startsWith('#') ? color : `#${color}`
  }
  return color
}
